// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"249":"2b051e22","949":"f2fc0930","965":"2d19e580"}[chunkId] + ".js";
};